// extracted by mini-css-extract-plugin
export default {"container":"ListProperties_container__wFy0P","sort":"ListProperties_sort__TLVZi","arrow":"ListProperties_arrow__pzln0","arrow_active":"ListProperties_arrow_active__8+A9b"};